/**
 * @desc 根据来源单号获取附件信息
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<Array<defs.rms.AssociatedFilesResponseDto>>;
export function request(
  params: API.rms.associatedFiles.getAssociatedFileList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/associatedFiles/getAssociatedFileList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
